import { ResearchFile } from "../../../api/research.types";
import { ResearchesFileAction } from "./researches.file.types";

export const researchesFileRequestAction = (params: { research_id: number }): ResearchesFileAction => ({ type: 'RESEARCHES_FILE_REQUEST', params })
export const researchesFileSuccessAction = (file: ResearchFile): ResearchesFileAction => ({ type: 'RESEARCHES_FILE_SUCCESS', params: file })
export const researchesFileFailureAction = (error?: any): ResearchesFileAction => ({ type: 'RESEARCHES_FILE_FAILURE', params: error })

export const researchesFileClearAction = (): ResearchesFileAction => ({ type: 'RESEARCHES_FILE_CLEAR' })